module.exports = __webpack_public_path__ + "img/shop-logo.040f5d9d.png";